module.exports = __webpack_public_path__ + "media/images/mobile/city_img/g3-4078e7e8a87bf10be8c94cd5f171d2c0.png";